import { ICustomTextEntry } from '../../../interfaces/scheduler_interfaces';
import { IQuery } from 'core-ts-types';
import { Query } from 'utility-ts-orm';
import { SchedulerModel } from '../models/scheduler_model';
import * as _4 from 'lodash4';

export class SchedulerCustomTextQuery implements IQuery {
  private _result: Record<ICustomTextEntry['nk'], ICustomTextEntry['text']>;

  constructor(private ngSchedulerModel: SchedulerModel) {
    Query.registerQuery(this, ngSchedulerModel);
  }

  get result() {
    this._result = _4.reduce(
      this.ngSchedulerModel.read().customtext,
      (prev, customText) => ({ [customText.nk]: customText.text, ...prev }),
      {}
    );
    return this._result;
  }

  run() {
    return this;
  }
}

angular.module('capability-ng-scheduler').service('ngSchedulerCustomTextQuery', SchedulerCustomTextQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/queries/scheduler_custom_text_query.ts